module.exports = __webpack_public_path__ + "static/img/ex_w1.80636db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ex_w1.jpg
// module id = /ex6
// module chunks = 1